import CloseIcon from '@mui/icons-material/Close';
import {
  Autocomplete,
  Button,
  Checkbox,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Stack,
  tableCellClasses,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import { format } from 'date-fns';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Box } from '@mui/system';
import { useCallback, useEffect, useState } from 'react';
import { MdWatchLater } from 'react-icons/md';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import BrudCrumbs from '../../components/BreadCrumbs';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import { fDate, fDateTime1 } from '../../utils/formatTime';
import ApiErrorMessage from '../Global/ApiErrorMessage';
import { NOT_AVAILABLE } from '../Global/Constants';
import CallCenterService from '../services/CallCenterService';
import partnerService from '../services/partnerService';
import globalService from '../services/globalServices';
import { isValidValue } from '../../utils/CommonFunction';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import useCallCenterSelector from '../../store/Slice/CallCenterList/CallCenterListSelector';
import {
  getEmployementTypeList,
  getSubEmployementTypeList
} from '../../store/Slice/CallCenterList/CallCenterListSlice';

const { StateList, CityList } = partnerService;
const { GetAllAssignableStatuses, UpdateStatus, AddressType } = CallCenterService;
const { MasterListType } = globalService;

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 12,
    padding: '6px',
    height: '42.5px',
    fontWeight: 500,
    textTransform: 'uppercase',
    color: '#0d4689'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
    padding: '4px 6px',
    height: '42.5px'
  }
}));

function UpdateCallCenter() {
  const navigate = useNavigate();
  const [openAppointment, setOpenAppointment] = useState({ status: false, indexVal: null });
  const [openFollowUp, setOpenFollowUp] = useState({ status: false, indexVal: null });
  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState('md');
  const [updateStatusList, setUpdateStatusList] = useState([]);
  const [selectedItemList, setSelectedItemList] = useState([]);
  const [stateListMenu, setStateListMenu] = useState([]);
  const [cityListMenu, setCityListMenu] = useState([]);
  const [openApiError, setOpenApiError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [dialogOpen, setDialogOpen] = useState(false);
  const [validationMsg, setValidationMsg] = useState('');
  const [addressTypeMenu, setAddressTypeMenu] = useState([]);

  const { LoginData } = useLoginSelector();
  const { EmployementTypeData, SubEmployementTypeData } = useCallCenterSelector();
  // console.log('EmployementTypeData', EmployementTypeData);
  // const { getEmployementTypeList } = useCallCenterSelector();

  const dispatch = useDispatch();

  // console.log('getEmployementTypeList', getEmployementTypeList);
  const handleStatus = (e, index) => {
    const selectedValue = e.target.value;
    if (JSON.parse(selectedValue).stageStatusName === 'Follow Up') {
      setOpenFollowUp({ status: true, indexVal: index });
    } else if (JSON.parse(selectedValue).stageStatusName === 'Lead') {
      handleOpenLeadDialog(e, index);
    }
    const prevArray = selectedItemList;
    prevArray[index].status = selectedValue;
    setSelectedItemList([...prevArray]);
  };

  const handleOpenLeadDialog = async (e, index) => {
    setOpenAppointment({ status: true, indexVal: index });
    const obj = {
      companyId: LoginData?.companyId,
      employmentCategoryId: 10000000, //
      returnConfiguredTypesOnly: true
    };
    dispatch(getSubEmployementTypeList(obj));
    const StateCredentials = {
      countryId: 101,
      searchLiteral: ''
    };

    const StateListApiResponse = await StateList(StateCredentials, LoginData?.jwt);

    if (StateListApiResponse.action_status === 'success') {
      setStateListMenu(StateListApiResponse.data);
    } else {
      setStateListMenu([]);
    }

    const type = 'ADDRESS_TYPE';
    const AddressTypeApiResponse = await MasterListType(type, LoginData?.jwt);
    if (AddressTypeApiResponse.status === 'success') {
      setAddressTypeMenu(AddressTypeApiResponse.data.masterTypes);
    } else {
      setAddressTypeMenu([]);
    }
  };

  const handleFollowUpSubmit = (e, indexVal) => {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() - 1);
    if (selectedItemList[indexVal].followUpAppointmentDetails.appointmentDate === '') {
      setDialogOpen(true);
      setValidationMsg('Please enter appointment date');
      return;
    } else if (
      currentDate > new Date(selectedItemList[indexVal].followUpAppointmentDetails.appointmentDate)
    ) {
      setDialogOpen(true);
      setValidationMsg('Please enter valid appointment date');
      return;
    }

    if (selectedItemList[indexVal].followUpAppointmentDetails.appointmentTime === '') {
      setDialogOpen(true);
      setValidationMsg('Please enter appointment time');
      return;
    }

    const prevArray = selectedItemList;
    prevArray[indexVal].followUpAppointmentDetails.isSubmitClicked = true;
    setSelectedItemList([...prevArray]);
    setOpenFollowUp({ status: false, indexVal: null });
  };

  const handleAppointmentSubmit = (e, indexVal) => {
    const pattern = /^[6-9][0-9]{9}$/;
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() - 1);
    if (selectedItemList[indexVal].leadConversionDetailsModel.purpose === '') {
      setDialogOpen(true);
      setValidationMsg('Please enter purpose type');
      return;
    }
    if (selectedItemList[indexVal].leadConversionDetailsModel.prospectName === '') {
      setDialogOpen(true);
      setValidationMsg('Please enter prospect name');
      return;
    }
    if (!pattern.test(selectedItemList[indexVal].leadConversionDetailsModel.prospectMobile)) {
      setDialogOpen(true);
      setValidationMsg('Please enter valid mobile number');
      return;
    }
    if (selectedItemList[indexVal].leadConversionDetailsModel.appointmentDate === '') {
      setDialogOpen(true);
      setValidationMsg('Please enter appointment date');
      return;
    } else if (
      currentDate > new Date(selectedItemList[indexVal].leadConversionDetailsModel.appointmentDate)
    ) {
      setDialogOpen(true);
      setValidationMsg('Please enter valid appointment date');
      return;
    }
    if (selectedItemList[indexVal].leadConversionDetailsModel.addressType === ' ') {
      setDialogOpen(true);
      setValidationMsg('Please select address type');
      return;
    }
    if (selectedItemList[indexVal].leadConversionDetailsModel.address === '') {
      setDialogOpen(true);
      setValidationMsg('Please enter address');
      return;
    }
    if (selectedItemList[indexVal].leadConversionDetailsModel.stateListData === null) {
      setDialogOpen(true);
      setValidationMsg('Please select state');
      return;
    }
    if (selectedItemList[indexVal].leadConversionDetailsModel.cityListData === null) {
      setDialogOpen(true);
      setValidationMsg('Please select city');
      return;
    }
    if (selectedItemList[indexVal].leadConversionDetailsModel.pinCode === '') {
      setDialogOpen(true);
      setValidationMsg('Please enter pin code');
      return;
    } else if (
      selectedItemList[indexVal].leadConversionDetailsModel.pinCode.length !== 6 ||
      selectedItemList[indexVal].leadConversionDetailsModel.pinCode.length > 6
    ) {
      setDialogOpen(true);
      setValidationMsg('Please enter valid pin code');
      return;
    }
    if (selectedItemList[indexVal].leadConversionDetailsModel.subEmploymentCategoryId === null) {
      setDialogOpen(true);
      setValidationMsg('Please Select Subemployment Category');
      return;
    }
    if (
      selectedItemList[indexVal].leadConversionDetailsModel.showDifferAddress &&
      selectedItemList[indexVal].leadConversionDetailsModel.pinCode1 === ''
    ) {
      setDialogOpen(true);
      setValidationMsg('Please enter pin code');
      return;
    } else if (
      (selectedItemList[indexVal].leadConversionDetailsModel.showDifferAddress &&
        selectedItemList[indexVal].leadConversionDetailsModel.pinCode1.length !== 6) ||
      (selectedItemList[indexVal].leadConversionDetailsModel.showDifferAddress &&
        selectedItemList[indexVal].leadConversionDetailsModel.pinCode1.length > 6)
    ) {
      setDialogOpen(true);
      setValidationMsg('Please enter valid pin code');
      return;
    }

    const prevArray = selectedItemList;
    prevArray[indexVal].leadConversionDetailsModel.isSubmitClicked = true;
    setSelectedItemList([...prevArray]);

    setOpenAppointment({ status: false, indexVal: null });
  };

  const handleFollowUpCloseIcon = (e) => {
    const prevArray = selectedItemList;
    const details = prevArray[openFollowUp.indexVal].followUpAppointmentDetails;

    if (
      isValidValue(details?.appointmentDate) &&
      isValidValue(details?.appointmentTime) &&
      details?.isSubmitClicked
    ) {
      setOpenFollowUp({ status: false, indexVal: null });
    } else {
      prevArray[openFollowUp.indexVal].status = ' ';
      setSelectedItemList([...prevArray]);
      setOpenFollowUp({ status: false, indexVal: null });
    }
  };

  const handleAppointmentCloseIcon = (e) => {
    const prevArray = selectedItemList;
    const details = prevArray[openAppointment.indexVal].leadConversionDetailsModel;

    if (
      isValidValue(details?.purpose) &&
      isValidValue(details?.prospectName) &&
      isValidValue(details?.prospectMobile) &&
      isValidValue(details?.appointmentDate) &&
      isValidValue(details?.addressType) &&
      isValidValue(details?.address) &&
      isValidValue(details?.landmark) &&
      isValidValue(details?.stateListData) &&
      isValidValue(details?.cityListData) &&
      isValidValue(details?.pinCode) &&
      isValidValue(details?.comments) &&
      details?.showDifferAddress &&
      details?.isSubmitClicked
    ) {
      setOpenAppointment({ status: false, indexVal: null });
    } else {
      prevArray[openAppointment.indexVal].status = ' ';
      setSelectedItemList([...prevArray]);
      setOpenAppointment({ status: false, indexVal: null });
    }
  };

  const handleUpdate = async (e) => {
    const objArray = [];
    selectedItemList.forEach((item, index) => {
      if (item.status !== ' ' && JSON.parse(item.status).stageStatusName === 'Follow Up') {
        const obj = {
          leadId: item.leadId,
          stageId: item.stageId,
          stageStatusId: JSON.parse(item.status).stageStatusId,
          userId: LoginData?.userId,
          followUpAppointmentDetails: {
            appointmentDate: item.followUpAppointmentDetails.appointmentDate,
            appointmentTime: item.followUpAppointmentDetails.appointmentTime
          },
          comments: item.comments
        };
        objArray.push(obj);
      } else if (item.status !== ' ' && JSON.parse(item.status).stageStatusName === 'Lead') {
        const appointmentDateTime = item.leadConversionDetailsModel.appointmentDate;
        const obj = {
          leadId: item.leadId,
          stageId: item.stageId,
          stageStatusId: JSON.parse(item.status).stageStatusId,
          userId: LoginData?.userId,
          leadConversionDetailsModel: {
            purpose: item.leadConversionDetailsModel.purpose,
            addressTypeId: item.leadConversionDetailsModel.addressType,
            employmentTypeId:
              item.leadConversionDetailsModel.subEmploymentCategoryId?.employmentSubcategoryId ||
              null,
            prospectName: item.leadConversionDetailsModel.prospectName,
            prospectMobile: item.leadConversionDetailsModel.prospectMobile,
            qualifiedBy: LoginData?.userId,
            appointmentStartDate: appointmentDateTime
              ? format(new Date(appointmentDateTime), 'yyyy-MM-dd')
              : null,
            appointmentStartTime: appointmentDateTime
              ? format(new Date(appointmentDateTime), 'HH:mm')
              : null,
            address: item.leadConversionDetailsModel.address,
            landmark: item.leadConversionDetailsModel.landmark,
            provinceId: item.leadConversionDetailsModel.stateListData
              ? item.leadConversionDetailsModel.stateListData?.stateId
              : null,
            cityId: item.leadConversionDetailsModel.cityListData
              ? item.leadConversionDetailsModel.cityListData.cityId
              : null,
            pinCode: item.leadConversionDetailsModel.pinCode,
            appointmentComments: item.leadConversionDetailsModel.comments,
            pinCode2: item.leadConversionDetailsModel.showDifferAddress
              ? item.leadConversionDetailsModel.pinCode1
              : ''
          },
          comments: item.comments
        };
        objArray.push(obj);
      } else if (item.status !== ' ') {
        const obj = {
          leadId: item.leadId,
          stageId: item.stageId,
          stageStatusId: JSON.parse(item.status).stageStatusId,
          userId: LoginData?.userId,
          comments: item.comments
        };
        objArray.push(obj);
      }
    });

    if (objArray.length === selectedItemList.length) {
      const UpdateStatusApi = await UpdateStatus(objArray, LoginData?.jwt);
      if (UpdateStatusApi.status === 'success') {
        setSelectedItemList([]);
        navigate('/call-center');
      } else {
        setOpenApiError(true);
        setErrorMessage('Something went wrong !');
      }
    } else {
      setDialogOpen(true);
      setValidationMsg('Please select status');
    }
  };

  const getCityList = async (e, newValue) => {
    const CityListApiResponse = await CityList(
      {
        searchLiteral: '',
        stateId: newValue.stateId ? newValue.stateId : null
      },
      LoginData?.jwt
    );

    if (CityListApiResponse.action_status === 'success') {
      setCityListMenu(CityListApiResponse.data);
    } else {
      setCityListMenu([]);
    }
  };

  const getEmployementType = useCallback(() => {
    const obj = {
      companyId: LoginData?.companyId
    };
    dispatch(getEmployementTypeList(obj));
  }, [LoginData]);

  useEffect(() => {
    getEmployementType(); // call center list
  }, []);

  const getSubEmployementType = useCallback(() => {
    const selectedEmployment =
      selectedItemList[openAppointment.indexVal]?.leadConversionDetailsModel?.employmentCategoryId;

    if (!selectedEmployment) return;

    const obj = {
      companyId: LoginData?.companyId,
      employmentCategoryId: selectedEmployment.employmentCategoryId, // 👈 here
      returnConfiguredTypesOnly: true
    };

    dispatch(getSubEmployementTypeList(obj));
  }, [LoginData, selectedItemList, openAppointment.indexVal, dispatch]);

  useEffect(() => {
    getSubEmployementType();
  }, [
    selectedItemList[openAppointment.indexVal]?.leadConversionDetailsModel?.employmentCategoryId
  ]);

  useEffect(async () => {
    const localSelectedItem = JSON.parse(localStorage.getItem('selectedItem'));

    const GetAllAssignableStatusesApi = await GetAllAssignableStatuses(
      localSelectedItem[0]?.stageId,
      LoginData?.jwt
    );
    if (GetAllAssignableStatusesApi.status === 'success') {
      setUpdateStatusList(GetAllAssignableStatusesApi.data);
    }

    if (localSelectedItem && localSelectedItem.length > 0) {
      localSelectedItem.forEach((item, index) => {
        item.status = ' ';
        item.comments = '';
        item.followUpAppointmentDetails = {
          appointmentDate: '',
          appointmentTime: '',
          isSubmitClicked: false
        };
        item.leadConversionDetailsModel = {
          purpose: '',
          prospectName: '',
          prospectMobile: '',
          qualifiedBy: '',
          addressType: ' ',
          appointmentDate: '',
          appointmentTime: '',
          address: '',
          landmark: '',
          stateListData: null,
          cityListData: null,
          employmentTypeId: null,
          pinCode: '',
          pinCode1: '',
          comments: '',
          showDifferAddress: false,
          isSubmitClicked: false
        };
      });
      setSelectedItemList(localSelectedItem);
    } else {
      setSelectedItemList([]);
    }
  }, [LoginData]);

  return (
    <Page title="Partner Management System || Call Center">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle info="Update Call Status" />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>

          <Box className="tableBox" mb={3}>
            <TableContainer sx={{ minWidth: 800, overflow: 'auto', background: 'white' }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="">Prospect Name</StyledTableCell>
                    <StyledTableCell>Last Status</StyledTableCell>
                    <StyledTableCell align="">New Status</StyledTableCell>
                    <StyledTableCell align="">Comments</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {selectedItemList.length > 0
                    ? selectedItemList.map((item, index) => (
                        <StyledTableRow>
                          <StyledTableCell align="">
                            {item.customerName ? item.customerName : `${NOT_AVAILABLE}`}
                          </StyledTableCell>
                          <StyledTableCell align="">
                            {item.status ? item.callCenterStatus : `${NOT_AVAILABLE}`}
                            {item.callCenterStatus && item.callCenterStatus === 'Follow Up' ? (
                              <Tooltip
                                title={
                                  item.followUpDateTime ? fDateTime1(item.followUpDateTime) : ''
                                }
                                placement="top"
                                arrow
                              >
                                <IconButton className="followUpIcon">
                                  <MdWatchLater size={18} />
                                </IconButton>
                              </Tooltip>
                            ) : (
                              ' '
                            )}
                          </StyledTableCell>
                          <StyledTableCell align="">
                            <Select
                              fullWidth
                              inputProps={{
                                className: `textInput textInputTable customSelectBox dissabledMenu${item.status}`
                              }}
                              value={item.status}
                              onChange={(e) => {
                                handleStatus(e, index);
                              }}
                              sx={{ minWidth: '200px' }}
                            >
                              <MenuItem value=" " disabled>
                                Select Status
                              </MenuItem>

                              {updateStatusList.length > 0
                                ? updateStatusList.map((item1, index1) => (
                                    <MenuItem value={JSON.stringify(item1)} key={index1}>
                                      {item1.stageStatusName}
                                    </MenuItem>
                                  ))
                                : ''}
                            </Select>
                          </StyledTableCell>
                          <StyledTableCell align="">
                            <TextField
                              fullWidth
                              inputProps={{
                                className: 'textInput textInputTable'
                              }}
                              placeholder="Write Your Comments"
                              sx={{ minWidth: '200px' }}
                              value={item.comments}
                              onChange={(e) => {
                                const prevArray = selectedItemList;
                                prevArray[index].comments = e.target.value;
                                setSelectedItemList([...prevArray]);
                              }}
                            />
                          </StyledTableCell>
                        </StyledTableRow>
                      ))
                    : ''}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <Box className="" textAlign="right">
            <Button variant="contained" className="mainBtn" onClick={(e) => handleUpdate(e)}>
              Update
            </Button>
          </Box>

          <Dialog
            className="PopupBox"
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            open={openFollowUp.status}
            fullWidth
          >
            <DialogTitle className="popupTitle">
              <Typography variant="h6">Follow Up</Typography>
              <IconButton
                onClick={(e) => {
                  handleFollowUpCloseIcon(e);
                }}
                size="small"
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent dividers>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Box>
                    <FormControl required fullWidth className="formGroup">
                      <Typography variant="body1" className="formLabel">
                        Date
                      </Typography>
                      <TextField
                        type="date"
                        id="Date"
                        inputProps={{ className: 'textInput' }}
                        fullWidth
                        placeholder="Date"
                        value={
                          selectedItemList[openFollowUp.indexVal]?.followUpAppointmentDetails
                            .appointmentDate
                        }
                        onChange={(e) => {
                          const prevArray = selectedItemList;
                          prevArray[
                            openFollowUp.indexVal
                          ].followUpAppointmentDetails.appointmentDate = e.target.value;
                          setSelectedItemList([...prevArray]);
                        }}
                      />
                    </FormControl>
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box>
                    <FormControl required fullWidth className="formGroup">
                      <Typography variant="body1" className="formLabel">
                        Time
                      </Typography>
                      <TextField
                        type="time"
                        id="time"
                        inputProps={{ className: 'textInput' }}
                        fullWidth
                        placeholder="Time"
                        value={
                          selectedItemList[openFollowUp.indexVal]?.followUpAppointmentDetails
                            .appointmentTime
                        }
                        onChange={(e) => {
                          const prevArray = selectedItemList;
                          prevArray[
                            openFollowUp.indexVal
                          ].followUpAppointmentDetails.appointmentTime = e.target.value;
                          setSelectedItemList([...prevArray]);
                        }}
                      />
                    </FormControl>
                  </Box>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={(e) => {
                  handleFollowUpSubmit(e, openFollowUp.indexVal);
                }}
                variant="contained"
                className="mainBtn"
              >
                Submit
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            className="PopupBox"
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth={fullWidth}
            maxWidth={maxWidth}
            open={openAppointment.status}
          >
            <DialogTitle className="popupTitle">
              <Typography variant="h6">Appointment</Typography>
              <IconButton
                onClick={(e) => {
                  handleAppointmentCloseIcon(e);
                }}
                size="small"
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>

            <DialogContent dividers>
              <Grid container spacing={{ xs: 1, sm: 2, md: 2 }}>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl required fullWidth className="formGroup">
                    <TextField
                      id=""
                      inputProps={{ className: 'textInput' }}
                      fullWidth
                      placeholder="Type Purpose"
                      value={
                        selectedItemList[openAppointment.indexVal]?.leadConversionDetailsModel
                          .purpose
                      }
                      onChange={(e) => {
                        const prevArray = selectedItemList;
                        prevArray[openAppointment.indexVal].leadConversionDetailsModel.purpose =
                          e.target.value;
                        setSelectedItemList([...prevArray]);
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl required fullWidth className="formGroup">
                    <TextField
                      id="prospect_name"
                      inputProps={{ className: 'textInput' }}
                      fullWidth
                      placeholder="Type Prospect Name"
                      value={
                        selectedItemList[openAppointment.indexVal]?.leadConversionDetailsModel
                          .prospectName
                      }
                      onChange={(e) => {
                        const prevArray = selectedItemList;
                        prevArray[
                          openAppointment.indexVal
                        ].leadConversionDetailsModel.prospectName = e.target.value;
                        setSelectedItemList([...prevArray]);
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl required fullWidth className="formGroup">
                    <TextField
                      id="Mobile"
                      type="number"
                      inputProps={{ className: 'textInput' }}
                      fullWidth
                      placeholder="Type Prospect Mobile"
                      value={
                        selectedItemList[openAppointment.indexVal]?.leadConversionDetailsModel
                          .prospectMobile
                      }
                      onChange={(e) => {
                        const prevArray = selectedItemList;
                        prevArray[
                          openAppointment.indexVal
                        ].leadConversionDetailsModel.prospectMobile = e.target.value;
                        setSelectedItemList([...prevArray]);
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl required fullWidth className="formGroup">
                    <TextField
                      type="datetime-local"
                      id="Date1"
                      inputProps={{ className: 'textInput' }}
                      fullWidth
                      placeholder="Select Appointment Date Time"
                      value={
                        selectedItemList[openAppointment.indexVal]?.leadConversionDetailsModel
                          .appointmentDate
                      }
                      onChange={(e) => {
                        const prevArray = selectedItemList;
                        prevArray[
                          openAppointment.indexVal
                        ].leadConversionDetailsModel.appointmentDate = e.target.value;
                        setSelectedItemList([...prevArray]);
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl required fullWidth className="formGroup">
                    <Select
                      fullWidth
                      inputProps={{
                        className: `textInput customSelectBox dissabledMenu${
                          selectedItemList[openAppointment.indexVal]?.leadConversionDetailsModel
                            .addressType
                        }`
                      }}
                      value={
                        selectedItemList[openAppointment.indexVal]?.leadConversionDetailsModel
                          .addressType
                      }
                      onChange={(e) => {
                        const prevArray = selectedItemList;
                        prevArray[openAppointment.indexVal].leadConversionDetailsModel.addressType =
                          e.target.value;
                        setSelectedItemList([...prevArray]);
                      }}
                      sx={{ minWidth: '200px' }}
                    >
                      <MenuItem value=" " disabled>
                        Select Address Type
                      </MenuItem>
                      {addressTypeMenu.length > 0
                        ? addressTypeMenu.map((item, index) => (
                            <MenuItem value={item.typeId}>{item.typeName}</MenuItem>
                          ))
                        : ''}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl required fullWidth className="formGroup">
                    <TextField
                      id="Address"
                      inputProps={{ className: 'textInput' }}
                      fullWidth
                      placeholder="Type Appointment Address"
                      value={
                        selectedItemList[openAppointment.indexVal]?.leadConversionDetailsModel
                          .address
                      }
                      onChange={(e) => {
                        const prevArray = selectedItemList;
                        prevArray[openAppointment.indexVal].leadConversionDetailsModel.address =
                          e.target.value;
                        setSelectedItemList([...prevArray]);
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl required fullWidth className="formGroup">
                    <TextField
                      id="Landmark"
                      inputProps={{ className: 'textInput' }}
                      fullWidth
                      placeholder="Type Appointment Landmark"
                      value={
                        selectedItemList[openAppointment.indexVal]?.leadConversionDetailsModel
                          .landmark
                      }
                      onChange={(e) => {
                        const prevArray = selectedItemList;
                        prevArray[openAppointment.indexVal].leadConversionDetailsModel.landmark =
                          e.target.value;
                        setSelectedItemList([...prevArray]);
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl required fullWidth className="formGroup">
                    <Autocomplete
                      id="combo-box-demo"
                      options={stateListMenu}
                      size="small"
                      value={
                        selectedItemList[openAppointment.indexVal]?.leadConversionDetailsModel &&
                        selectedItemList[openAppointment.indexVal].leadConversionDetailsModel
                          .stateListData !== null
                          ? selectedItemList[openAppointment.indexVal].leadConversionDetailsModel
                              .stateListData.stateName
                          : null
                      }
                      onChange={(e, newValue) => {
                        setCityListMenu([]);
                        const prevArray = selectedItemList;
                        prevArray[
                          openAppointment.indexVal
                        ].leadConversionDetailsModel.cityListData = null;
                        prevArray[
                          openAppointment.indexVal
                        ].leadConversionDetailsModel.stateListData = newValue;
                        setSelectedItemList([...prevArray]);
                        if (newValue) {
                          getCityList(e, newValue);
                        }
                      }}
                      getOptionLabel={(option) =>
                        option.stateName
                          ? option.stateName
                          : selectedItemList[openAppointment.indexVal].leadConversionDetailsModel
                              .stateListData.stateName
                      }
                      renderOption={(props, option) => <li {...props}>{option.stateName}</li>}
                      renderInput={(params) => (
                        <TextField {...params} fullWidth placeholder="Select State" />
                      )}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl required fullWidth className="formGroup">
                    <Autocomplete
                      id="combo-box-demo1"
                      options={cityListMenu}
                      size="small"
                      value={
                        selectedItemList[openAppointment.indexVal]?.leadConversionDetailsModel &&
                        selectedItemList[openAppointment.indexVal].leadConversionDetailsModel
                          .cityListData !== null
                          ? selectedItemList[openAppointment.indexVal].leadConversionDetailsModel
                              .cityListData.cityName
                          : null
                      }
                      onChange={(e, newValue) => {
                        const prevArray = selectedItemList;
                        prevArray[
                          openAppointment.indexVal
                        ].leadConversionDetailsModel.cityListData = newValue;
                        setSelectedItemList([...prevArray]);
                      }}
                      getOptionLabel={(option) =>
                        option.cityName
                          ? option.cityName
                          : selectedItemList[openAppointment.indexVal]?.leadConversionDetailsModel
                              ?.cityListData?.cityName
                      }
                      renderOption={(props, option) => <li {...props}>{option.cityName}</li>}
                      renderInput={(params) => (
                        <TextField {...params} fullWidth placeholder="Select City" />
                      )}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl required fullWidth className="formGroup">
                    <TextField
                      id="Pin Code"
                      type="number"
                      inputProps={{ className: 'textInput' }}
                      fullWidth
                      placeholder="Type Pin Code"
                      value={
                        selectedItemList[openAppointment.indexVal]?.leadConversionDetailsModel
                          .pinCode
                      }
                      onChange={(e) => {
                        const prevArray = selectedItemList;
                        prevArray[openAppointment.indexVal].leadConversionDetailsModel.pinCode =
                          e.target.value;
                        setSelectedItemList([...prevArray]);
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl required fullWidth className="formGroup">
                    <Autocomplete
                      options={EmployementTypeData || []}
                      size="small"
                      value={
                        selectedItemList[openAppointment.indexVal]?.leadConversionDetailsModel
                          ?.employmentCategoryId || null
                      }
                      onChange={(e, newValue) => {
                        const prevArray = [...selectedItemList];

                        prevArray[
                          openAppointment.indexVal
                        ].leadConversionDetailsModel.employmentCategoryId = newValue;

                        // reset sub type when parent changes
                        prevArray[
                          openAppointment.indexVal
                        ].leadConversionDetailsModel.subEmploymentCategoryId = null;

                        setSelectedItemList(prevArray);

                        // 🔥 Call Sub Employment API
                        if (newValue) {
                          const obj = {
                            companyId: LoginData?.companyId,
                            employmentCategoryId: newValue.employmentCategoryId,
                            returnConfiguredTypesOnly: true
                          };
                          dispatch(getSubEmployementTypeList(obj));
                        }
                      }}
                      getOptionLabel={(option) => option?.employmentCategoryName || ''}
                      isOptionEqualToValue={(option, value) =>
                        option.employmentCategoryId === value?.employmentCategoryId
                      }
                      renderInput={(params) => (
                        <TextField {...params} fullWidth placeholder="Select Employment type" />
                      )}
                    />
                  </FormControl>
                </Grid>
                {SubEmployementTypeData?.length > 0 && (
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl required fullWidth className="formGroup">
                      <Autocomplete
                        options={SubEmployementTypeData || []}
                        size="small"
                        value={
                          selectedItemList[openAppointment.indexVal]?.leadConversionDetailsModel
                            ?.subEmploymentCategoryId || null
                        }
                        onChange={(e, newValue) => {
                          const prevArray = [...selectedItemList];
                          prevArray[
                            openAppointment.indexVal
                          ].leadConversionDetailsModel.subEmploymentCategoryId = newValue;
                          setSelectedItemList(prevArray);
                        }}
                        getOptionLabel={(option) => option?.employmentSubcategoryName || ''}
                        isOptionEqualToValue={(option, value) =>
                          option.employmentSubcategoryId === value?.employmentSubcategoryId
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            placeholder="Select Sub Employment type"
                          />
                        )}
                      />
                    </FormControl>
                  </Grid>
                )}

                <Grid item xs={12} sm={12} md={12}>
                  <FormControl required fullWidth className="formGroup">
                    <TextField
                      id="Comments"
                      multiline
                      rows={2}
                      inputProps={{ className: '' }}
                      fullWidth
                      placeholder="Write Comments"
                      value={
                        selectedItemList[openAppointment.indexVal]?.leadConversionDetailsModel
                          .comments
                      }
                      onChange={(e) => {
                        const prevArray = selectedItemList;
                        prevArray[openAppointment.indexVal].leadConversionDetailsModel.comments =
                          e.target.value;
                        setSelectedItemList([...prevArray]);
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        size="medium"
                        onChange={(e) => {
                          const prevArray = selectedItemList;
                          prevArray[
                            openAppointment.indexVal
                          ].leadConversionDetailsModel.showDifferAddress = e.target.checked;
                          setSelectedItemList([...prevArray]);
                        }}
                      />
                    }
                    label="Is your residence address differs from above"
                  />
                </Grid>
                {selectedItemList[openAppointment.indexVal]?.leadConversionDetailsModel
                  ?.showDifferAddress ? (
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl required fullWidth className="formGroup">
                      <TextField
                        id="Pin Code1"
                        type="number"
                        inputProps={{ className: 'textInput' }}
                        fullWidth
                        placeholder="Pin Code"
                        value={
                          selectedItemList[openAppointment.indexVal]?.leadConversionDetailsModel
                            .pinCode1
                        }
                        onChange={(e) => {
                          const prevArray = selectedItemList;
                          prevArray[openAppointment.indexVal].leadConversionDetailsModel.pinCode1 =
                            e.target.value;
                          setSelectedItemList([...prevArray]);
                        }}
                      />
                    </FormControl>
                  </Grid>
                ) : (
                  ''
                )}
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={(e) => {
                  handleAppointmentSubmit(e, openAppointment.indexVal);
                }}
                variant="contained"
                className="mainBtn"
              >
                Submit
              </Button>
            </DialogActions>
          </Dialog>
          <ApiErrorMessage
            openApiError={openApiError}
            setOpenApiError={setOpenApiError}
            errorMessage={errorMessage}
          />

          <Dialog
            open={dialogOpen}
            onClose={(e) => setDialogOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <DialogContentText id="alert-dialog-description">{validationMsg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={(e) => setDialogOpen(false)}>Retry</Button>
            </DialogActions>
          </Dialog>
        </Box>
      </Container>
    </Page>
  );
}
export default UpdateCallCenter;
